export default __webpack_public_path__ + "static/finland-82a3d232a4dec4017f1b4756911e3eb5.png";